import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "react-multi-lang";
import "react-datepicker/dist/react-datepicker.css";
import Sidebar from "./Sidebar";
import { Link } from "react-router";
import "react-widgets/dist/css/react-widgets.css";

class AuthenticationSuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            maskedAadhaar: '',
        };
    }

    componentDidMount() {
        // Get from localStorage
        const maskedAadhaar = localStorage.getItem('aadhaar_masked');

        // Set to state if it exists
        if (maskedAadhaar) {
            this.setState({ maskedAadhaar });

            // Delete it immediately after using
            localStorage.removeItem('aadhaar_masked');
        }
    }


    render() {
        let Mainprops = this.props;
        return (
            <section
                className="back-dashboard widget-sidebar-context mt-3"
                id="my-sidebar-context"
            >
                <div className="container">
                    <div className="row">
                        <Link className="navbar-toggler widget-sidebar-toggler text-white">
                            Sidebar
                        </Link>
                        <Sidebar route={Mainprops.route} />
                        <main className="col col-md-9 second-side ps-4 pb-3 h-100">
                            <div className="panel-heading">
                                <h6 className="mb-0">
                                    {this.props.t("verifyAdhar.adhar_title", {
                                        param: "react",
                                    })}
                                </h6>
                            </div>

                            <div>
                                <div className="tab-content profile-page authen-failure-container pdingspc">
                                    <img alt='authen-failure' src="/images/authen-success.png" ></img>
                                    <h3 className="authen-success-title">{this.props.t("verifyAdhar.authen_success", {
                                        param: "react",
                                    })}</h3>
                                    <p className="authen-failure-content"> {this.props.t("verifyAdhar.your_adhar", {
                                        param: "react",
                                    })}
                                        <span className="adhar-clr">{this.state.maskedAadhaar}</span> <br /> {this.props.t("verifyAdhar.authen_verified", {
                                            param: "react",
                                        })}.
                                    </p>
                                    <button
                                        aria-label="Back"
                                        type="button"
                                     className="authen-back-btn wdset1" onClick={() => this.props.router.push("/myaccount")}>{this.props.t("verifyAdhar.backBtn", {
                                        param: "react",
                                    })}</button>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = (store) => {
    return store;
};

export default connect(mapStateToProps)(translate(AuthenticationSuccess));
